// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"InputBox_inputBox__1spWI","slide-in-right":"InputBox_slide-in-right__2rajX","slide-out-right":"InputBox_slide-out-right__3Cj1U"};